import { render, staticRenderFns } from "./TicketPublishCurrentStatus.vue?vue&type=template&id=0ba84270&"
import script from "./TicketPublishCurrentStatus.vue?vue&type=script&lang=js&"
export * from "./TicketPublishCurrentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports